<script>

export default {
  name: 'UtDescriptions',
  props: {
    title: {
      type: String,
      required: false
    },
    column: {
      type: Number,
      default: 3
    },
    data: {
      type: Object,
      default: {}
    },
    config : {
      type: Array,
      required: true,
      default: () => []
    },
    size: {
      type: String,
      required: false,
      default: 'medium',
      validator: (value) => {
        return ['mini', 'small', 'medium', 'large'].includes(value);
      }
    },
    theme: {
      type: String,
      required: false,
      default: 'info',
      validator: (value) => {
        return ['light', 'info'].includes(value);
      }
    }
  },
  mounted() {
    // this.convertDict()
  },
  data(){
    return {
      dict: {}//枚举字典缓存
    }
  },
  methods: {
    //挂载时把用到的枚举字典缓存，配合convertContent方法使用，提高性能
    // convertDict (){
    //   const optionsKeyArr =  this.config.map(item => item.optionKey)
    //   // 是否有需要转换的枚举字典
    //   if (optionsKeyArr  && optionsKeyArr.length > 0){
    //     optionsKeyArr.map(key => {
    //       this.dict[key] = loadEnumDict(key)
    //     })
    //   }
    // },

    //判断是否存在枚举字典，存在则返回枚举值，否则返回原始值或默认值
    // convertContent(data,config){
    //   // 存在枚举字典
    //   if (config.optionKey){
    //     return this.dict[config.optionKey][data[config.prop]].label || '--'
    //   }else {
    //     return  data[config.prop] || '--'
    //   }
    // }
  }
}

</script>

<template>
  <div class="desc-container">
    <el-descriptions :column="column" :size="size">
      <template slot="title">
        <template v-if="title">
          <div v-if="theme === 'info'">{{ title }}</div>
          <div v-if="theme === 'light'" class="desc-header">
            <div class="light-title">
              <span class="light-title-bar" />
              <span>{{ title }}</span>
            </div>
          </div>
        </template>
      </template>
      <template v-for="item in config">
        <el-descriptions-item :label="item.label">
          <!--
            判断逻辑：
            1. $slots[item.prop] 检查父组件是否存在以 prop 命名的具名插槽
            2. 如果存在，渲染插槽内容，并将当前行的数据 item 和完整数据 data 传递给插槽使用者
            3. 如果不存在，回退到显示 data[item.prop] 的默认值
          -->
<!--              v-if="$slots[item.prop]"-->
          <slot
              v-if="$scopedSlots[item.prop] || $slots[item.prop]"
              :name="item.prop"
              :row="data"
              :item="item"
          ></slot>

          <span v-else>
            {{ data[item.prop] }}
          </span>
        </el-descriptions-item>
      </template>
    </el-descriptions>
  </div>
</template>

<style scoped>
.desc-container{
  width: 100%;
}

::v-deep .el-descriptions__header {
  margin-bottom: 12px;
}

::v-deep .el-descriptions-item__label.has-colon{
  color: #86909C;
}
::v-deep .el-descriptions-item__label.has-colon::after {
   content: ''  !important;
 }

::v-deep .el-descriptions__body{
  color: #1E253D;
}

.desc-header{
  font-size: 12px;
}
.light-title {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  color: #4E5969;
  line-height: 1.4;

}

.light-title-bar {
  display: inline-block;
  width: 3px;
  height: 14px;
  margin-right: 4px;
  background-color: #ff981e;
  border-radius: 1px;
  flex-shrink: 0;
}

</style>
